import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FundOfferEntityNormalized } from '../../../../../../../../../store/product/types';
import { FundsAssetProvider } from '../../../../../contexts/products/Funds';
import { ItemDetails } from '../Details';

import { FundsListItemDesktop } from './desktop';
import { FundsListItemMobile } from './mobile';
import { FundsListItemTablet } from './tablet';

export namespace FundsListItemTypes {
  export interface Props {
    offer: FundOfferEntityNormalized;
  }
}

export const FundsListItem: React.FC<FundsListItemTypes.Props> = ({ offer }) => {
  const fundsListItem = useBreakpointValue({
    base: <FundsListItemMobile offer={offer} />,
    sm: <FundsListItemTablet offer={offer} />,
    lg: <FundsListItemDesktop offer={offer} />,
  });

  return (
    <FundsAssetProvider>
      <ItemDetails />
      {fundsListItem}
    </FundsAssetProvider>
  );
};
